import { render, staticRenderFns } from "./PlateformForm.vue?vue&type=template&id=42130ed2&scoped=true&"
import script from "./PlateformForm.vue?vue&type=script&lang=ts&"
export * from "./PlateformForm.vue?vue&type=script&lang=ts&"
import style0 from "./PlateformForm.vue?vue&type=style&index=0&id=42130ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42130ed2",
  null
  
)

export default component.exports